import { TicketFooterRow } from '@/mytickets/detail/views/TicketFooter';
import React from 'react';

export const AutomaticOddsAdvantage = ({ multiplier }) => (
    <TicketFooterRow rowInfo={`${multiplier}`} rowTitle="ticketus.extras.automaticOddsAdvantage" />
);
